import React from 'react';
import { withRouter } from 'react-router-dom';
import {Button,Row,Card,Form,Input,Radio,Checkbox,Spin} from 'antd';
import BaseContent from 'components/BaseContent';
import {AUTH_TYPE,SDK} from 'utils/bundleConst';
import style from './index.less';
import InputValidate from 'components/InputValidate';
const FormItem = Form.Item;
const RadioGroup = Radio.Group;
class BundleEdit extends React.Component {

    constructor(props){
        super(props);
        this.state = {};
        this.hasChange = false;
        this.ValidateInput = InputValidate(Input,props.form);
    }

    componentWillReceiveProps(nextProps){
        if(nextProps.defaultInfo != null && !this.hasChange){
            this.hasChange = true;
            //第一次变化设置
            this.props.form.setFieldsValue(nextProps.defaultInfo);
        }
    }

    onCreate=()=>{
        this.props.form.validateFields((error, values)=> {
            if(!error){
                values.auth_type = AUTH_TYPE.online.value;
                this.props.onSubmit && this.props.onSubmit(values);
            }
        });
    }

    regexString() {
        const platform = this.props.form.getFieldValue('platform');
        switch(platform) {
            case 'ios':
                return new RegExp(/^[a-zA-Z0-9-]+(\.[a-zA-Z0-9-]+)*(\.\*)?$/);
            case 'android':
                return new RegExp(/^[a-zA-Z]\w*(\.[a-zA-Z]\w*)+(.\*)?$/);
            default:
                return new RegExp();
        }
    }

    render() {
        const { getFieldDecorator } = this.props.form;
        const ValidateInput = this.ValidateInput;
        const formItemLayout = {
            labelCol: {
                span:5,
                style:{width:'115px',display: 'inline-block'}

            },
            wrapperCol: {
                span:19,
                className:style.wrapperCol
            },
        };
        let title,buttonTest;
        if(this.props.isEdit){
            title = 'Edit Bundle';
            buttonTest = 'Create';
        } else{
            title = 'Bound to new Bundle ID';
            buttonTest = 'Create';
        }
        const footer = (
            <Row>
                <Button type="primary" style={{width: 120,marginLeft:60}} onClick={this.onCreate}>{buttonTest}</Button>
                <Button style={{width: 120,marginLeft:60}} onClick={()=> this.props.history.go(-1)}>Back</Button>
            </Row>
        );

        return (
            <Spin spinning={this.props.loading}>
                <BaseContent style={{minHeight: 0}} footer={footer}>
                    <Card title={title} bordered={false} style={{color:'#515666'}}>
                        <Form>
                            <FormItem
                                label="Platform"
                                {...formItemLayout}
                            >
                                {getFieldDecorator('platform', {
                                    initialValue:'android'
                                })(
                                    <RadioGroup onChange={this.onChange}>
                                        <Radio value='android'>Android</Radio>
                                        <Radio value='ios'>iOS</Radio>
                                    </RadioGroup>
                                )}
                            </FormItem>
                            <FormItem
                                label="Bundle ID"
                                {...formItemLayout}
                            >
                                {getFieldDecorator('bundle_id', {
                                    rules: [
                                        { required: true, message: 'Bundle ID cannot be empty' },
                                        { validator:(rule, value, callback)=>{
                                            const regex = this.regexString();
                                            if(value === ''){
                                                return callback();
                                            }
                                            if(!regex.test(value) || value.length > 100){
                                                callback('The format is incorrect');
                                            }else{
                                                callback();
                                            }
                                        }}
                                    ],
                                    validateTrigger: 'onBlur'
                                })(
                                    <ValidateInput style={{width:345}}/>
                                )}
                            </FormItem>
                            <FormItem
                                label="SDK"
                                {...formItemLayout}
                            >
                                {getFieldDecorator('permissions', {
                                    rules: [
                                        { required: true, message: 'Please select SDK' },
                                    ]
                                })(
                                    <Checkbox.Group style={{ width: '564px',marginTop:8 }}>
                                        {SDK.map(item=>{
                                            return <div class={style.sdk}>
                                                <Checkbox value={item.value}>{item.label}</Checkbox>
                                                <p dangerouslySetInnerHTML={{__html:item.desc}}></p>
                                            </div>;
                                        })}
                                    </Checkbox.Group>
                                )}
                            </FormItem>
                        </Form>
                    </Card>
                </BaseContent>
            </Spin>
        );
    }
}
export default withRouter(Form.create()(BundleEdit));



// WEBPACK FOOTER //
// ./src/components/BundleEdit/index.js